export const COMPARE_CORROSION_LOGS_FILTERS = {
  LOGS: 'logs',
  JOINTS: 'joints',
  CLASS: 'class',
  DIRECTION: 'direction',
};

export const COMPARE_CORROSION_LOGS_FILTERS_LABELS = {
  JOINTS: 'by Joint',
  LOGS: 'by Logs',
  CLASS: 'by Class',
  DIRECTION: 'by Direction',
};

export const ADD_CORROSION_LOG_FORM_FEILDS = {
  FILE_NAME: 'customFileName',
  LOG_DATE: 'logDate',
  SERVICE_PROVIDER: 'serviceProviderId',
  TOOL: 'toolId',
};
export const ADD_CORROSION_LOG_FORM_FEILDS_LABELS = {
  FILE_NAME: 'File Name',
  LOG_DATE: 'Log Date',
  SERVICE_PROVIDER: 'Service Provider',
  TOOL: 'Tool',
};

export const CORROSION_LOG_ACTIONS = {
  LOAD_CORROSION_LOG_TEMPLATE: 'LOAD_CORROSION_LOG_TEMPLATE',
  ADD_CORROSION_LOG_FILE: 'ADD_CORROSION_LOG_FILE',
  LOAD_CORROSION_LOGS_LIST: 'LOAD_CORROSION_LOGS_LIST',
  DELETE_CORROSION_LOG: 'DELETE_CORROSION_LOG',
  LOAD_SERVICE_PROVIDERS: 'LOAD_SERVICE_PROVIDERS',
  LOAD_CORROSION_MEASURE_TOOLS: 'LOAD_CORROSION_MEASURE_TOOLS',
  CREATE_NEW_SERVICE_PROVIDER: 'CREATE_NEW_SERVICE_PROVIDER',
  CREATE_NEW_CORROSION_MEASURE_TOOL: 'CREATE_NEW_CORROSION_MEASURE_TOOL',
  CREATE_NEW_CORROSION_LOG: 'CREATE_NEW_CORROSION_LOG',
  LOAD_CORROSION_LOG_FILE: 'LOAD_CORROSION_LOG_FILE',
  LOAD_CORROSION_LOGS_FILTERS: 'LOAD_CORROSION_LOGS_FILTERS',
  LOAD_COMPARE_FILES_DATA: 'LOAD_COMPARE_FILES_DATA',
};

export const MAX_NUMBER_OF_FILES_ALLOWED = 2;

export const MAX_UPLOAD_FILE_SIZE = 3 * 1024 * 1024;

export const ALLOWED_FILE_TYPES = ['xlsx', 'xls'];
